const APIEndpoints = {
  CENTRAL_ONBOARDING: {
    VENDORS_MASTER: '/epr/vendors/master',
    CLIENTS: '/epr/clients',
    CLIENTS_TEMPLATE_VIEW: '/epr/clients/view',
    VENDORS: '/epr/vendors',
    KAMBYDETAILS: '/epr/kam',
    UPDATE_KAMDETAILS: '/epr/kam/update',
    SAVE_KAMDETAILS: '/epr/kam/create',
    VENDOR_TEMPLATE_VIEW: '/epr/clients/view',
    ADD_SP_TO_RECYCLER: '/epr/sp/add/recycler',
    FETCH_MAPPED_SP: '/epr/mapped-sp',
  },

  // Global Configs for rules and restrictions
  FETCH_EPR_CONFIGS: '/epr/config/epr-config',

  // Service Provider API for BRAND AND SERVICE PROVIDER LOGINS

  SERVICE_PROVIDER: '/epr/work-orders/service-providers',

  //Catalog API
  BROWSE_NODES: '/catalog/customer/browse-nodes',
  BROWSE_NODES_MATERIAL: '/epr/browse-node-material/fetch-all',
  FETCH_ALL_RULES: '/epr/conversion-rule/fetch-all-rules',
  IMPACT_METRICS: '/sustainability_item_metrics.json',
  NODE_ITEMS: '/catalog/epr/items',
  //Target API
  TARGETS: '/epr/targets',
  // TARGETS: 'http://localhost:3000/TargetResponseFlat.json',
  TARGETS_UNALLOCATED: '/epr/targets/unallocated',
  STATES: '/epr/states', //wantsDistricts.equals=true
  //Auth API
  LOGIN: '/stakeholders/customer/authenticate',
  LOGOUT_LOGS: '/stakeholders/epr/user-login-logout-logs',
  GET_GSTIN_BY_PAN: '/stakeholders/pan-info/',
  REGISTER: '/stakeholders/epr/registration',
  RESET_PASS_REQUEST: '/stakeholders/account/reset_password/init',
  CREATE_PASS: '/stakeholders/account/createPassword',
  RESET_PASS: '/stakeholders/account/reset_password/finish',
  USER_VALIDATION: '/stakeholders/epr/validate-user',
  USER_VALID: '/stakeholders/epr/check-user-exists',
  AUTHENTICATE_GOOGLE_TOKEN: '/stakeholders/authenticate-google-auth-token',
  // DownloadFile API
  EMAIL_ATTACHMENT_DOWNLOAD: '/epr/file-download/email-attachment-url',

  //Account API
  GET_ACCOUNT: '/stakeholders/account',
  DEVICE_DETAILS: '/communication/devices',
  DELETE_KYC_DOCUMENT: '/stakeholders/epr/document',
  UPDATE_CONTACT_PERSON_DETAILS: '/stakeholders/epr/customer/contact-person',
  UPDATE_PROFILE_INFO_DETAILS: '/stakeholders/epr/customer-profile',
  UPLOAD_PROFILE_LOGO: '/stakeholders/customer/profile-logo',
  UPDATE_PASSWORD: '/stakeholders/account/change-password',
  UPDATE_PROFILE: '/stakeholders/epr/profile-update',
  GET_ACTIVITY_LOG: '/communication/notifications',
  GET_TIMELINE_LOG: '/audit/audit-logs?isTimeLineEvent=true&sort=createdAt,desc',
  SET_LOG_READ: '/communication/notifications/tapped',
  GET_COMMUNICATION_CATEGORIES: '/communication/category',
  GET_ALL_PERMISSIONS_FOR_ROLE: '/stakeholders/service/authority',
  ADD_ROLE_PERMISSIONS: '/stakeholders/service/authority',
  UPDATE_CLIENT: '/stakeholders/epr/customer-profile',
  UPDATE_CLIENT_CONTACT_INFO: '/stakeholders/epr/customer/contact-person',
  UPDATE_CLIENT_KYC_DOCUMENTS: '/stakeholders/documents',
  DELETE_CLIENT_KYC_DOCUMENT: '/stakeholders/epr/document',
  //PrivacyPolicy apis
  GET_CUSTOMER_SESSION: '/stakeholders/admin/customers/get-session',
  GET_EPR_CUSTOMERS: '/stakeholders/admin/customers',
  GET_USER_POLICY: '/stakeholders/user-policy',
  GET_LATEST_POLICY: '/stakeholders/privacy-policy',
  UPDATE_USER_POLICY: '/stakeholders/user-policy',
  //Brand API
  // BRAND: '/stakeholders/epr/brands',
  BRAND_STATS: '/epr/targets/brand/dashboard-stats',
  // Work orders
  WORK_ORDERS: '/epr/work-orders',
  BRAND_WO_LIST: '/epr/brand-work-order-list',
  WORK_ORDERS_FILTER_FACETS: '/epr/work-orders/facets',
  WORK_ORDERS_PENDING_ITEMS: '/epr/work-orders/pending-items',
  PENDING_WO: '/epr/work-orders/pending-wo',
  DELETE_WO_DOC: '/epr/documents/delete',
  WORK_ORDER_ITEMS: '/epr/work-order-items',
  WORK_ORDER_ITEM_PRICE_CHANGE: '/epr/work-order-items/pricechange',
  DOWNLOAD_WORKORDERS: '/epr/download/work-order',
  DOWNLOAD_DELIVERIES_WORKORDER: '/epr/download/work-order/deliveries',
  WORK_ORDERS_CLOSE: '/epr/work-orders/close-wo',
  WORK_ORDERS_OPEN: '/epr/work-orders/open-wo',
  WORK_ORDER_LOG: '/epr/work-order-status-logs',
  WORK_ORDERS_BY_BRAND: '/epr/work-orders/brand',
  WORK_ORDERS_SUMMARY: '/epr/brand/work-orders-summary',
  BRAND_WORK_ORDERS_SUMMARY_CARDS: '/epr/brand/work-order-qty-summary',
  BRAND_WORK_ORDERS: '/epr/fetch-brandWo',
  VENDOR_WORK_ORDERS_FULFILLED: '/epr/work-orders/fetch-vendor-wo-fulfilled',
  CPCB_WALLET_INFO: '/stakeholders/epr/cpcb-wallet-info',
  VENDOR_WO_SUMMARY_CARDS: '/epr/vendor/work-orders-summary',
  VENDOR_WO_QTY_SUMMARY: '/epr/vendor/work-order-qty-summary',
  FETCH_BRAND_WO_SUSTAINABILITY_METRICS: '/epr/work-orders/brand/sustainability-metrics',

  BRAND_WORK_ORDERS: '/epr/fetch-brandWo',
  VENDOR_WORK_ORDERS_FULFILLED: '/epr/work-orders/fetch-vendor-wo-fulfilled',
  //Execution
  EXECUTION_FILTER_FACETS: '/epr/targets/execution/facets',
  EXECUTION: '/epr/execution/demand',
  EXECUTION_PERFORMANCE_LEADERBOARD: '/epr/performance-leaderboard/execution-team',
  //summmary
  FETCH_SUMMARY_STATUS: '/epr/summary/status',
  //Dashboard
  DASHBOARD_MET_STATS: '/epr/met-stats',
  DASHBOARD_OVERVIEW: '/epr/dashboard-overview',
  DASHBOARD_OVERVIEW_BY_STATE: '/epr/dashboard-states',
  DASHBOARD_OVERVIEW_BY_ITEM: '/epr/dashboard-items',
  DASSHBOARD_OVERVIEW_BY_BRAND: '/epr/dashboard-brands',
  DASSHBOARD_FACETS: '/epr/dashboard/facets',
  DASHBOARD_VENDOR_OVERVIEW: '/epr/executionSummary/vendor-overview',
  DASHBOARD_FETCH_CARD_DATA: '/epr/dashboard',
  CENTRAL_DASHBOARD: '/epr/central-dashboard',
  //Reports
  GET_VENDOR_REPORTS: '/epr/reports?vendor=true',
  GET_TARGET_REPORTS: '/epr/reports?vendor=false',
  GET_MONTHLY_FULFILLMENT_SUMMARY: '/epr/reports/monthlyFulfillment',
  GET_CPCB_REPORT: '/epr/reports/cpcb',
  GET_FULFILLMENT_REPORT: '/epr/reports/fulfillmentSummary',
  GET_PDF_PAGE: '/epr/reports/pdf-page',
  GET_SELF_DECLARATION_CERTIFICATE: '/epr/reports/declarationCertificate',
  GET_SIGNATURES: '/epr/reports/declaration-signature ',
  SEND_FULFIMENT_COMMUNICATION: '/epr/work-orders/fulfilment-plan/communication',
  BRAND_FULFILLMENT_REPORT: '/epr/e-wasteBrandFulfillmentReport',
  CERTIFICATE_PREVIEW_MAIL: '/epr/certificate/preview-mail',
  CERTIFICATE_SEND_MAIL: '/epr/certificate/send-mail',
  CERTIFICATE_AUDIT_LOGS: '/epr/certificate/audit-logs',
  CERTIFICATE_COR_DRAFT_SUMMARY_CARDS: '/epr/certificate/summary/draft',
  CERTIFICATE_GLOBAL_SUMMARY_CARDS: '/epr/certificate/summary',
  FETCH_CERTIFICATES_ELIGIBLE: '/epr/certificate/eligible-for-cor',
  FETCH_CERTIFICATE_AUDIT_LOGS: '/epr/certificate/audit-logs',
  FETCH_CERTIFICATE_AUDIT_LOGS_MAIL_PREVIEW: '/epr/certificate/audit-logs/preview-mail',
  CERTIFICATE_UPLOADED_SUMMARY: '/epr/certificate/summary/uploaded',
  // file uploads
  EPR_SIGNED_URL: '/epr/documents/signed-url',
  STAKEHOLDERS_SIGNED_URL: '/stakeholders/documents/signed-url',
  BULK_UPLOAD: '/epr/delivery-automation/upload',
  DISCARD_BATCH: '/epr/delivery-automation/remove-file',
  BATCH_DETAILS_LIST: '/epr/batch-processing/get-batches',
  PROCESS_DOC: '/epr/delivery-automation/process-batch',
  // Get base64 file
  GET_CSV_BASE64: '/epr/document-extraction/download-transactions',
  //ServiceProvider API
  FILTERED_SERVICE_PROVIDERS: '/stakeholders/epr/work-orders',
  FILTERED_CLIENT_SERVICE_PROVIDERS: '/stakeholders/epr/work-orders?onlyFromReceived=true&',
  MAP_RECYCLER_TO_SP: '/epr/service-provider',
  GET_SP_RECYCLERS: '/epr/service-provider/',
  GET_SP_BRIEF_OVERVIEW_BY_CATEGORY: '/epr/inventory/customer-inventory-spdetails',
  GET_VENDOR_UNIT_DETAILS: '/epr/inventory/customer-inventory',
  //Delivery API
  DELIVERIES: '/epr/deliveries',
  DELIVERIES_UPLOAD_DOC: '/epr/delivery-documents',
  DELIVERY_DOCS_ARCHIVE: '/epr/deliveries/archive-certificates',
  DELIVERIES_CHANGE_TYPE: '/epr/delivery-documents/doc-type',
  ASSIGN_DELIVERY: '/epr/deliveries/assign',
  ATTRIBUTION_MONTH_CHANGE: '/epr/deliveries/attribution-month-change',
  STATUS_CHANGE: '/epr/deliveries/delivery-status-change',
  APPROVE_DELIVERY: '/epr/deliveries/mark-as-approved',
  DISPUTE_DELIVERY: '/epr/deliveries/mark-as-dispute',
  DELIVERY_DOCUMENT: '/epr/delivery-documents/',
  DISPUTE_DOCUMENT: '/epr/delivery-documents/mark-as-disputed',
  APPROVE_DOCUMENT: '/epr/delivery-documents/mark-as-approved',
  RESOLVE_DOCUMENT: '/epr/delivery-documents/mark-as-resolved',
  DELIVERY_DOCUMENT_META_DATA: '/epr/delivery-documents/meta-data',
  DELIVERY_FACETS: '/epr/deliveries/facets',
  DOWNLOAD_DELIVERIES: '/epr/download/deliveries',
  APPROVE_ALLOCATION: '/epr/deliveries/approve-allocation',
  QTY_SUBMIT_FOR_APPROVAL: '/epr/deliveries/service-provider/submit',
  GENERATE_EWAYBILL_EINVOICE: '/epr/deliveries/generate-einvoice-ewb?',
  GENERATE_INVOICE: '/epr/deliveries/reserve-invoice-number?',
  VIEW_INVOICE: '/epr/deliveries/invoice-preview?',
  GET_ORDER_SUMMARY: '/epr/executionSummary/orders',
  GET_VENDOR_ORDER_SUMMARY: '/epr/unplanned-brand-workorder',
  GET_DELIVERY_SUMMARY: '/epr/executionSummary/deliveries',
  GET_EXECUTION_DELIVERIES: '/epr/deliveries',
  GET_ALL_DOC_TYPES: '/epr/deliveries/configurations',
  GET_RECYCLER_ADDRESSES: '/epr/deliveries/recycler-source-details',
  GET_SOURCE_ADDRESSES: '/epr/deliveries/source-details',
  GET_RECYCLER_FROM_MP: '/epr/recyclers?size=1000',
  STATUS_TO_INTRANSIT: '/epr/deliveries/mark-as-in-transit',
  SEND_PICKUP_SUPERVISOR_SMS: '/epr/deliveries/supervisor/pick/send-sms',
  SEND_SMSTO_DRIVER: '/tracking/subscribe',
  SEND_DROP_SUPERVISOR_SMS: '/epr/deliveries/supervisor/destination/send-sms',
  SUPERUSERDELIVERIES: '/epr/deliveries/superuser',
  BULKDELETE: '/epr/delivery-documents/bulk-delivery-documents',
  GENERATE_SALVAGE_INVOICE: '/epr/invoices/create-salvage-invoice?',
  UPDATE_SALVAGE_PRICE: '/epr/deliveries/update-salvage-price?',
  SEND_SUBSCRIPTION: '/epr/deliveries/send-subscription',
  BATCH_DETAILS: '/epr/batch-processing/batch-details',
  AUTOMATE_DELIVERY: '/epr/delivery-automation/automate',
  FETCH_WORKORDER_DETAILS: '/epr/batch-processing/work-order',
  GET_SERVICE_PROVIDERS: '/epr/service-provider',
  GET_RECYCLERS: '/epr/recyclers',
  GET_RECYCLERS_INFO: '/epr/recyclers-info',
  GET_DOC_EXTRACTION: '/epr/document-extraction/transaction',
  GET_DOC_PREVIEW: '/epr/documents/document-preview',
  UPDATE_TRANSACTION: '/epr/document-extraction/update-transaction',
  MAP_DELIVERY_TO_WO: '/epr/map-dl-wo',
  GET_VENDOR_BRAND_WORK_ORDERS: '/epr/brand-vendor-work-orders',
  GET_DEALLOCATION_DELIVERIES: '/epr/deliveries/de-allocation',
  GET_DEALLOCATION_LOGS: '/epr/deliveries/de-allocation-logs',
  UPDATE_TRANSACTION_STATUS: '/epr/document-extraction/update-transaction-status',
  BULK_DELIVERIES_SUBMIT_FOR_REVIEW: '/epr/document-extraction/submit-for-review',
  FETCH_WO_LIST_FOR_BATCH: '/epr/document-extraction/fetch-work-orders',
  ALLOCATE_APPROVED_DELIVERY: '/epr/delivery-automation/automate/v2',
  GET_METRICS: '/epr/batch-processing/batch-details/metrics',
  GET_METRICS_BY_BATCH_ID: '/epr/batch-processing/batch-details/metrics',
  FETCH_CLOSEST_QTY_DELIVERIES: '/epr/batch-processing/deliveries/closest-qty-match',
  FETCH_BATCH_LOGS: '/epr/batch-processing/batch-logs',
  FETCH_TRANSACTION_LOGS: '/epr/document-extraction/transaction-logs',
  REJECT_BATCH: '/epr/batch-processing/reject-batch',
  DELIVERY_ALLOCATION_SUMMARY: '/epr/document-extraction/allocation-summary',
  FETCH_DELIVERIES_CONFIG: '/epr/deliveries/config/delivery_document_rules',
  FETCH_POS_BY_RECYCLER: '/epr/batch-processing/vendor-mapped-pos',
  VALIDATE_BATCH_QTY_AGAINST_PO: '/epr/batch-processing/validate/batches-qty-against-po',
  //Roles API
  GET_ROLES_LIST: 'https://my-json-server.typicode.com/sravanthimunaga/recykal-api/roeldata',
  GET_ALL_PERMISSION: '/stakeholders/epr-permissions',
  GET_ALL_ROLES: '/stakeholders/epr-roles',
  GET_ALL_ROLE_PERMISSION: '/stakeholders/epr-role-permissions',
  GET_ALL_ROLES_LIST: '/stakeholders/service/authority',
  GET_ALL_PERMISSIONS_FOR_APP_CODE: '/stakeholders/service/permission',
  //Tickets
  TICKETS: '/epr/tickets',
  GET_USER: '/stakeholders/epr/users?sort=id,asc',
  GET_USERV2: '/stakeholders/epr/v2/users?sort=id,asc',
  DELETE_USER: '/stakeholders/delete-epr-user/',
  ENABLE_USER: '/stakeholders/enable-epr-user/',
  GET_ZONES_LIST: '/stakeholders/epr/zones',
  GET_INVOICES: '/epr/invoices',
  ACCOUNT_INVOICES: '/epr/invoices/accounted',
  CREATE_VENDOR_BILL: '/epr/invoices/vendor/bill/create',
  UPDATE_VENDOR_BILL: '/epr/invoices/vendor/bill/update',
  INVOICE_PO_NUMBER_STATUS: '/epr/invoices/status',
  GET_VENDOR_BILL_SUMMARY: '/epr/invoices/vendor/bill/summary/cards',
  GET_INVOICEABLE_DELIVERIES: '/epr/deliveries/invoiceable',
  GET_WORKORDER_PO_NUMBER: '/epr/work-orders-po',
  GET_INVOICEABLE_DELIVERIES_WO: '/epr/deliveries/work-order',
  GET_PAYMENTS: '/epr/payments',
  DOCUMENT_ATTACH: '/epr/documents/attach',
  WEIGHBRIDGE_CHECK: '/epr/deliveries/weighbridge-check?docType=',
  SUPERVISORS: '/epr/supervisors',
  TRANSPORTER: '/epr/transporters',
  DRIVER: '/epr/drivers',
  VEHICLE_NUMBER: '/epr/transporters/vehicle-details',
  DROPLOCATION: '/epr/recyclers?size=1000',
  SUPERVISOR_SEND_OTP: '/stakeholders/login/supervisor/request-otp',
  VERIFY_OTP: '/stakeholders/login/supervisor/verify-otp',
  // Tracking endpoints
  TRACKING: '/api/tracking/shipment',
  UNSUBSCRIBE: '/api/tracking/unsubscribe',
  AUTHENTICATE: '/epr/tracking/authenticate',
  SUBMIT_FOR_REVIEW: '/epr/deliveries/submit-for-review',
  FETCH_ULB: '/epr/ulbs',
  APPROVE_ULB_DOC: '/epr/ulb-doc/',
  UPLOAD_UNSIGNED_DOC: '/epr/ulb/',
  UPLOAD_SIGNED_DOC: '/epr/ulb-doc/',
  ULB_LITE: '/epr/ulbs/lite',
  SP_FETCH_ULB: '/epr/ulb-docs',
  GET_SPCB_LETTER_DATA: '/epr/deliveries',
  DOWNLOAD_SPCB_LETTER: '/epr/reports/spcb-letter',
  ADD_SPCB_STATE: '/epr/spcbs',
  GET_SPCB_LIST: '/epr/spcbs',
  GET_BRAND_FULFILLMENT_REPORT: '/epr/download/e-wasteBrandFulfillmentReportCsv',
  DOWNLOAD_COPROCESSRECYCLE_LETTER: '/epr/reports/co-processing-certificate',
  DOWNLOAD_RECYCLING_LETTER: '/epr/reports/recycler-certificate',
  GRAPH_DATA: '/epr/reports/monthlyFulfillment',
  PENDING_DELIVERY_WO: '/epr/pending-delivery-wo',
  EWASTE_BRANDS: '/epr/ewaste-brands',
  BRAND_DETAILS: '/epr/brand-specifications/',
  DELIVERY_DETAILS: '/epr/delivery-status-logs',
  VALIDATE_DELIVERIES: '/epr/deliveries/validate-deliveries',
  DELETE_DELIVERIES: '/epr/deliveries/bulk-delete',
  SUPPLY_FROM_VENDORS: '/epr/inventory/customer-inventory-planning',
  GET_INVOICE_LIST: '/epr/invoices/draft-invoices',
  GET_INVOICE_SUMMARY_CARDS: '/epr/invoices/summary/cards',
  GET_BRAND_DRAFT_INVOICES: '/epr/invoices/brand/draft-invoices',
  POST_INVOICE: '/epr/invoices',
  APPROVED_INVOICE_LIST: '/epr/invoices',
  APPROVED_INVOICE: '/epr/invoices/',
  ATTACH_INVOICE_DOCUMENT: '/epr/documents/attach',
  UPDATE_INVOICE_DOCUMENT: '/epr/documents/update-document',
  CREATE_PROMISE_INVOICE: '/epr/invoices/promises',
  GET_PROMISE_LIST: '/epr/invoices/promises',
  EDIT_PROMISED_INVOICE: '/epr/invoices/promises',
  DELETE_PROMISED_INVOICE: '/epr/invoices/promises/',
  FETCH_APPROVED_CARD_DETAILS: '/epr/invoices/approved-invoices-cards',
  DOWNLOAD_APPROVED_REPORT: '/epr/download/invoices',
  RECORD_PAYMENT: '/epr/payments',
  ASSIGN_INVOICE: '/epr/payments/invoice_payment',
  FETCH_PAID_INVOICES: '/epr/invoices',
  BRAND_APPROVE_INVOICE: '/epr/invoices/approved',
  BRAND_REJECT_INVOICE: '/epr/invoices/rejected',
  FETCH_PAYMENT_LIST: '/epr/payments',
  DELETE_DOCUMENT: '/epr/documents/delete/',
  EDIT_INVOICES: '/epr/invoices',
  DELETE_PWA_DELIVERY: '/epr/deliveries/assigned',
  DELIVERY_BULK_UPLOAD: '/epr/deliveries/bulk/upload-docs',
  GENERATED_INVOICES: '/epr/invoices/client/proforma-generated-invoices',
  GET_INVOICE_DETAILS_WITH_SPECIFICATION: '/epr/invoices/create/brand/',
  GENERATE_PROFORMA_INVOICE_PRO: '/epr/invoices/brand/proforma-invoices',
  CONFIRM_PROFORMA_INVOICE_PRO: '/epr/invoices/brand/invoices/create',
  DOWNLOAD_REPORT: '/epr/download/epr-report',
  DOWNLOAD_SUMMARY_REPORT: '/epr/download/epr-summary-report',
  DOWNLOAD_CREDIT_REPORT: '/epr/download/epr-credit-report',
  DOWNLOAD_FINANCE_MIS_REPORT: '/epr/reports/finance',
  DOWNLOAD_FULFILLMENT_TRACKER_REPORT: '/epr/download/fulfillment-time-tracker',
  INVOICE_SPECS: '/epr/invoice-specs',
  BRAND_INVOICE_TYPE_SAVE: '/epr/invoice-specs',
  BRAND_INVOICE_TYPE_GET: '/epr/invoice-specs/',
  BRAND_INVOICE_TYPE_UPDATE: '/epr/invoice-specs',
  ADVANCE_PROFORMA_INVOICE: '/epr/invoices/advance/proforma-invoices/',
  CUSTOMER_KAM_UPDATE: '/stakeholders/epr/update-customer-kam',
  GENERATE_PROFORMA_INVOICE: '/epr/invoices/client/proforma-invoices/',
  GET_PROFORMA_INVOICE: '/epr/invoices/client/proforma-invoices/',
  CREATE_INVOICE: '/epr/invoices/client/invoices/create',
  PREVIEW_INVOICE: '/epr/invoices/client/invoices/proforma/',
  MAP_DELIVERY_TO_INVOICE: '/epr/invoices/client/proforma-invoices-mapping/',
  INVOICE_VENDOR_WORK_ORDERS: '/epr/invoices/vendor-work-orders/by-ponumber',
  SUPPLY_WORK_AREA: '/epr/capacity-projections',
  DEMAND_WORK_AREA: '/epr/capacity/demands',
  CUSTOMER_CAPACITIES: '/epr/capacity/customer-capacities',
  BRAND_DOCUMENTS: '/epr/deliverable-docs',
  SUPPLY_BUSUINESS_TARGET: '/epr/fulfilment-capacities',
  DEMAND_BUSUINESS_TARGET: '/epr/business-targets',
  VENDOR_AVAILABILITY: '/epr/executionSummary/orders',
  CREATE_MARKETPLACE_WORK_ORDER: '/epr/work-orders/generate-mp-wo',
  FETCH_UNPLANNED_WORK_ORDERS: '/epr/work-orders',
  FETCH_UNPLANNED_WORK_ORDERS_NEW: '/epr/work-orders/planning',
  UNPLANNED_PLAN: '/epr/work-orders/',
  UPDATE_DRAFT_WORK_ORDER: '/epr/work-orders/resend-vendor-consent',
  DELETE_DRAFT_WORK_ORDER: '/epr/work-orders/',
  CREATE_DRAFT_WORK_ORDER: '/epr/vendor-work-orders',
  GET_MAPPED_SERVICE_PROVIDERS: '/epr/service/recycler/mapped/sps',
  GET_MAPPED_RECYCLERS: '/epr/service/sp/mapped/recyclers',
  MARKETPLACE_CREDITS: '/epr/deliveries/mp/get-credits',
  GENERATE_MARKETPLACE_WORK_ORDER: '/epr/work-orders/generate-mp-wo',
  PLANING_MODULES_CARDS: '/epr/plan-overview-data',
  AGGREGATOR_PV_CREATION_REQUEST: '/epr/deliveries/aggregator-pv-creation-req',
  CREATE_AGGREGATOR_PV: '/epr/deliveries/create-aggregator-pv',
  FETCH_BRANDWISE_PLANNED_WORK_ORDER_BY_ID: '/epr/work-orders/',
  FREE_WO_QUANTITY: '/epr/work-orders/free-qty',
  FETCH_BRAND_ALLOCATION_DETAILS: '/epr/work-order-items',
  FETCH_BRAND_ALLOCATION_DETAILS_NEW: '/epr/work-orders/mapping',
  ALLOCATE_WO_QUANTITY: '/epr/work-orders/replan-qty',
  ACCEPT_REJECT_DRAFT_WORK_ORDER: '/epr/work-orders/acceptVendorConsent',
  VENDOR_FULFILLMENT_DETAILS: '/epr/fulfilment-details',
  SAVE_VENDOR_FULFILLMENT_DETAILS: '/epr/fulfilment-details',
  UPDATE_VENDOR_FULFILLMENT_DETAILS: '/epr/fulfilment-capacities-update',
  FETCH_DELIVERABLES_LIST: '/epr/deliveries/get-docs-list',
  FETCH_SELECTED_DELIVERABLES_LIST: '/epr/customer-deliverable-docs/',
  SAVE_VENDOR_DELIVERABLES: '/epr/save-deliverable-docs',
  FETCH_REVISION_LOG: '/epr/capacitylogs/customer/',
  SAVE_VENDOR_ADDENDUM: '/epr/capacitylogs/capacity-revision-logs',
  DELETE_SELECTED_DELIVERABLES: '/epr/delete-by-doctype',
  // Vendor API
  ADD_RECYCLER: '/epr/sp/add/recycler',
  GET_VENDOR_CAPABILITIES: '/epr/get-capacities',
  UPDATE_VENDOR_CAPABILITIES: '/epr/update-fulfilment',
  UPLOAD_AGGREMENT: '/stakeholders/epr/service-providers/agreement/v2',
  ADD_CAPACITY: '/epr/inventory/add-capacity',
  INVENTORY_DETAILS: '/epr/inventory/get-planning-details',
  DELETE_CAPACITY: '/epr/inventory/delete-capacity',
  SAVE_CAPACITY: '/epr/save-category-capacity',
  GET_ADVANCE_PO_DATA: '/epr/purchase-order/fetch/advance-pos',

  // Execution Module
  BRAND_FULFILLMENT_TRACKING: '/epr/work-orders-execution',
  BRAND_CATEGORYWISE_FULFILLMENT_DATA: '/epr/work-order-items/fulfillment',
  VENDOR_FULFILLMENT_TRACKING: '/epr/service/vendor-fullfillment',
  VENDOR_WORK_ORDERS: '/epr/work-order-items/fulfillment/vendorworkorders',
  VENDOR_CATEGORYWISE_FULFILLMENT_DATA: '/epr/work-order-items/fulfillment/vendor',
  FETCH_VENDOR_WORKORDER_OVERVIEW_DETAILS:
    '/epr/work-order-items/fulfillment/overview/vendordetails',
  FETCH_DELIVERY_EXECUTION_DETAILS: '/epr/deliveries/execution/delivery-overview',
  UPDATE_BRAND_DELIVERY_STATUS: '/epr/deliveries/update-delivery-status',
  UPDATE_SP_LOGIN_DELIVERY_STATUS: '/epr/deliveries/service-provider/update-delivery-status',
  AUTO_ALLOCATION: '/epr/deliveries/assign/autoallocation',
  ADD_CERTIFICATE_DATE: '/epr/delivery-documents/certificate-date',
  PAYABLES_DOWNLOAD: '/epr/invoices/download-payables',
  DELINK_INVOICE: '/epr/invoices/client',
  UPDATE_BULK_DELIVERY_STATUS: '/epr/deliveries/update-bulk-delivery-status',
  FETCH_BULK_DELIVERY_DETAILS_BY_ID: '/epr/document-extraction/bulk-delivery-info',
  UPDATE_BULK_DELIVERY_APPROVED_STATUS: '/epr/document-extraction/update-status-to-in-review',
  GET_HSN_SAC_CODES: '/epr/deliveries/hsn-sac-codes',
  //Credits
  FETCH_WORKORDERS: '/epr/credits/fetch-work-orders',
  ASSIGN_CREDIT_INFO: '/epr/assign-credit-info',
  ADD_CREDIT_INFO: '/epr/credit-info',
  GET_CREDIT_INFORMATION: '/epr/credit-informations',
  VIEW_CREDIT_INFORMATION: '/epr/credit-information-view',
  GET_VISIBILE_RECYCLERS: '/epr/visible-recyclers',
  GET_TRANSACTIONS_LIST: '/epr/credit-transactions',
  FETCH_ALTERNATE_CREDITS_BY_ID: '/epr/alternate-credits',
  MAP_ALTERNATE_CREDITS: '/epr/map-alternate-credits',
  GET_VENDOR_WOS: '/epr/get-vendor-wo',
  MAP_CREDITS_VENDOR_WO: '/epr/map-vendor-credits',
  GET_CREDITS_SUMMARY: '/epr/credits/summary',
  GET_VENDOR_CLIENTS: '/epr/vendor-clients',
  FETCH_CREDITS_MAIL: '/epr/pending-credits/table-data',
  CREDITS_PREVIEW_MAIL: '/epr/pending-credits/preview-mail',
  CREDITS_SEND_MAIL: '/epr/pending-credits/send-mail',
  CREDIT_MAIL_LOGS: '/epr/pending-credits/logs',
  CREDIT_MAIL_AUDIT_PREVIEW: '/epr/pending-credits/logs-mail-preview',
  FETCH_VENDOR_WORK_ORDERS: '/epr/mapped-wo',
  FETCH_CERTIFICATE_DETAILS: '/epr/certificate',
  DELETE_CETIFICATE: '/epr/certificate/delete',
  FETCH_CERTIFICATES: '/epr/certificate/fetch-certificates',
  UPLOAD_CERTIFICATE: '/epr/certificate/document',
  UPDATE_CERTIFICATE: '/epr/certificate/update',
  FULFILLMENT_CATEGORY_WISE: '/epr/fulfillment-catagory-wise',
  FETCH_CREDIT_LOGS: '/epr/fetch-credit-logs',
  FETCH_CREDIT_BY_TRANSCATION_ID: '/epr/credit-info/validate/transaction-status-update',
  CREDIT_STAUTS_CHANGE: '/epr/credit-info/mark-approved',
  DELETE_CHILD_CREDIT: '/epr/credit-info/delete/child-transaction',
  FETCH_CREDITS_PREVIEW_MAIL: '/epr/approved-credits/email/preview',
  FETCH_CREDITS_EMAIL_SUMMARY: '/epr/credit-email-summary',
  SEND_BRAND_CONFIRMATION_MAIL: '/epr/credits-approved-notify',
  UPDATE_BRAND_CONSENT_STATUS: '/epr/public/consent-action',
  GET_CREDIT_CONFIRMATION_ATTACHMENT: '/epr/credit-confirmation-attachment',
  BULK_CREDITS_BRAND_CONFIRMATION: '/epr/credit-bulk-consent-update',
  FETCH_CREDITS_CONFIRMATION_SUMMARY_DATA: '/epr/credits-confirmation-summary-card',
  SINGLE_CREDIT_BRAND_CONFIRMATION: '/epr/credit-manual-consent-update',
  //Onboard Vendor
  GET_MARKETPLACE_GSTIN_BY_PAN: '/marketplace/gstin/',
  ADD_FULFILLMENT_DETAILS: '/epr/add-fulfilment-details',
  //PINCODES
  GET_DATA_BY_PINCODE: '/epr/service/pincode-data',
  //Prod Support
  GET_WORK_ORDERS: '/epr/work-orders-ids',
  UPDATE_PO_MAPPING: '/epr/update-po-mapping/',
  GET_ITEM_NAMES: '/epr/work-order-items/item-names',
  GET_ZOHO_ITEM_NAMES: '/epr/work-order-items/fetching-zoho-item',
  ADD_ZOHO_ITEM_MAPPING: '/epr/work-order-items/create-update-zoho-item',
  FETCH_GST_MAPPING: '/epr/zoho-customers',
  ADD_GSTIN_ZOHOID: '/epr/zoho-customers/add-gstin',
  GET_VENDOR_UNIT_IDS: '/epr/capacity/fetching-unit-id/',
  UPDATE_BUSINESS_TYPE: '/epr/capacity/update-business-type',
  //Purchase Order
  GET_PURCHASE_ORDER_SUMMARY: '/epr/purchase-order/advance/summary',
  PURCHASE_ORDER: '/epr/purchase-order/advance',
  GET_RECYCLERS_BY_SP: '/epr/service/sp/mapped/recyclers',
  GET_DOCUMENT_VIEW: '/epr/documents/signed-url',
  GET_DOCUMENT_FROM_ZOHO: '/epr/zoho/purchase-order',
  //Margin Approval
  VENDOR_PRICING: '/epr/module-attributes/vendor',
  BRAND_PRICING: '/epr/module-attributes/brand',
  MARGIN_APPROVAL_SUMMARY: '/epr/margin-approvals/summary',
  MARGIN_APPROVAL: '/epr/margin-approvals',
  GET_MAPPED_WORK_ORDERS: '/epr/purchase-order/advance',
  GET_PAYMENT_TERM: '/epr/get/payment-terms',
  GET_VENDOR_PRICING: '/epr/module-attributes',
  FETCH_VENDOR_PRICING: '/epr/module-attributes/vendor',
  GET_AUDIT_LOGS: '/epr/service/fetch-audit-logs',

  //Brand Fulfilment
  BRAND_FULFILMENT_SUMMARY: '/epr/brand/fulfillment-cards',
  BRAND_FULFILMENT: '/epr/brand/fulfillment-view',
  BRAND_FULFILMENT_OVERVIEW: '/epr/get-brand-fulfilment-overview',
  BRAND_DETAIL_DATA: '/epr/get-brand-fulfilment-list',
  VENDOR_FULFILMENT_OVERVIEW: '/epr/get-vendor-fulfilment-overview',
  VENDOR_DETAIL_DATA: '/epr/get-vendor-fulfilment-list',
  VENDOR_FULFILMENT_SUMMARY: '/epr/vendor/fulfillment-cards',
  VENDOR_FULFILMENT: '/epr/vendor/fulfillment-view',

  //Reusable Deliveries
  REUSABLE_DELIVERIES_SUMMARY: '/epr/deliveries/reusable/summary',
  REUSABLE_DELIVERIES_LIST: '/epr/document-extraction/reusable-deliveries-list',

  CREDITS_DRAFT_REASONS: '/epr/draft-reasons/CREDITS_DRAFT_REASONS',
  CREDIT_REASONS_SUMMARY: '/epr/credit-information/credit-reasons-summary',
  VENDOR_DOWNTIME_REASONS: '/epr/app-monitoring-logs/config/VENDOR_DOWNTIME_REASONS',
  SET_DOWNTIME: '/epr/app-monitoring-logs',
  DOWNTIME_HISTORY: '/epr/app-monitoring-logs',
  STOP_DOWNTIME: '/epr/app-monitoring-logs/stop-downtime',
  CPCB_LOGS: '/epr/app-monitoring-logs/cpcb-logs',
  SUBMIT_FOR_IN_REVIEW: '/epr/deliveries/submit-in-review',

  DRAFT_VERIFICATION_ISVALID: '/epr/document-extraction',
  DELIVERIES_DRAFT_REASON_UPDATE: '/epr/document-extraction/reason',
  DECLARE_CAPACITY_DETAILS: '/epr/capacity-details',
  UPDATE_CAPACITY_DETAILS: '/epr/capacity-details',
  FETCH_VENDOR_DETAILS: '/epr/capacity-details',
  VALIDATE_CAPACITY_DETAILS: '/epr/capacity-details/validate-capacity',
  CAPACITY_DETAILS_AUDIT_LOGS: '/epr/capacity-details/audit-logs',
  VENDOR_PURCHASE_ORDER_EXIST: '/epr/purchase-orders/capacity-details',
  FETCH_ADJUST_CAPACITY_DETAILS: '/epr/capacity-details/adjust-capacity',
  ADJUST_CAPACITY_DETAILS: '/epr/capacity-details/save-adjust-capacity',
  EXECUTION_CAPACITY_DETAILS: '/epr/capacity-details',
  BATCH_DELIVERY_PREVIEW_MAIL: '/epr/batch-processing/preview-dispute-doc',
  BATCH_DELIVERY_SEND_MAIL: '/epr/batch-processing/send-dispute-doc-mail',
  DELIVERY_MAIL_LOGS: '/epr/batch-processing/logs/disupute-doc-mail',
  DELIVERY_MAIL_AUDIT_PREVIEW: '/epr/batch-processing/logs/mail-preview',
};

export default APIEndpoints;
